"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asyncCompareRecipe = void 0;
const augmentative_iterable_1 = require("augmentative-iterable");
const recipes_1 = require("../recipes");
const count_async_1 = require("./count-async");
const take_async_1 = require("./take-async");
const basic_ingredients_async_1 = require("./basic-ingredients-async");
function asyncCompareRecipe(comparer) {
    return (0, recipes_1.comparisonRecipe)({
        ...basic_ingredients_async_1.basicAsync,
        count: count_async_1.countAsync,
        take: take_async_1.takeAsync,
        resolver: augmentative_iterable_1.resolverAsync,
        comparer,
    });
}
exports.asyncCompareRecipe = asyncCompareRecipe;
